// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3jj-i","inputWrap":"styles_inputWrap__2F7N7","input":"styles_input__3mjcW"};